// @flow

import React from 'react'
import styled from 'styled-components'
import { FormField, Label } from 'src/components/Form'
// $FlowFixMe
import { CardElement, injectStripe } from 'react-stripe-elements'
import type { Theme as ThemeType } from 'src/types'
import { Error } from 'src/components/Form'
import { captureWithSentry } from '../../helpers/handle-errors'
import { PAYMENT_TIMEOUT_DURATION } from '../../helpers/constants'

type Props = {
  theme: ThemeType,
  label: string,
  onReady: Function,
  onCheckIt: Function,
  stripe: any,
  amount: number,
  fullName: string,
  locationId: string,
  attemptTCPIntent: boolean,
  onTCPaymentSuccess: Function,
  onTCPaymentError: Function,
  onGettingSecret?: Function
}

const StyledPayment = styled.div`
  border-radius: 3px;
  border: solid 1px ${props => (props.hasErrors ? '#ff4a4a' : '#e1e6ec')};
  margin: 5px 0 0 0;
  ${props => (props.hasErrors ? 'margin-bottom: 50px;' : '')} padding: 14px 10px;
  box-sizing: border-box;
  height: 50px;
`

const createOptions = () => {
  return {
    style: {
      base: {
        fontSize: '16px',
        color: '#6e7b8c',
        fontFamily: 'Source Code Pro, monospace',
        fontWeight: 'normal',
        '::placeholder': {
          color: '#a2aebf'
        }
      },
      invalid: {
        color: '#ff4a4a',
        border: 'thin solid #ff4a4a'
      }
    }
  }
}

type State = {
  hasErrors: boolean,
  clientSecret: string
}

class PaymentDetails extends React.PureComponent<Props, State> {
  paymentDetails: Object
  timerId: TimeoutID | null = null
  _isMounted = false
  isFetching = false
  isTimedOut = false
  state = {
    hasErrors: false,
    clientSecret: ''
  }
  componentDidMount() {
    this._isMounted = true
  }
  componentWillUnmount() {
    this._isMounted = false
  }

  componentDidUpdate() {
    const { fullName, attemptTCPIntent, locationId } = this.props

    if (
      !!fullName &&
      locationId &&
      attemptTCPIntent &&
      fullName.length &&
      this._isMounted &&
      !this.isFetching
    ) {
      this.isFetching = true
      this._onPaymentAttempt()
    }
  }
  async _getStripeSecret() {
    const { amount, fullName, onTCPaymentError, locationId, onGettingSecret } = this.props
    const url = process.env.REACT_APP_STRIPE_PAYMENT_INTENT || ''
    const apiToken = process.env.REACT_APP_STRIPE_API_TOKEN || ''
    const requestData = {
      amount,
      full_name: fullName,
      building: locationId,
      service: 'application_form'
    }
    try {
      const response = await fetch(url, {
        method: 'post',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Token ${apiToken}`
        },
        body: JSON.stringify(requestData)
      })
      onGettingSecret && onGettingSecret()
      return await response.json()
    } catch (e) {
      this._isMounted && onTCPaymentError(e)
      captureWithSentry(e)
    }
  }

  _onReady = e => {
    const { onReady } = this.props
    if (!onReady) {
      return
    }
    this.paymentDetails = e
    onReady(e)
  }

  async _onPaymentAttempt() {
    const { onTCPaymentError, onTCPaymentSuccess } = this.props

    try {
      // $FlowFixMe
      const msResponse = await this._getStripeSecret()

      if (!msResponse || typeof msResponse !== 'object' || !msResponse.client_secret) {
        onTCPaymentError({ error: true, message: 'invalid client secret' })
        return
      }
      //

      this.isTimedOut = true
      //set up the timeout
      this.timerId = setTimeout(() => {
        //somehow timer is triggered when we cancel timeout
        this.isTimedOut &&
          this.captureError({
            code: 'Payment was unsuccessful',
            message: `Payment is timeout out`
          })
      }, PAYMENT_TIMEOUT_DURATION)

      const { client_secret } = msResponse
      const { paymentIntent, error } = await this.props.stripe.confirmCardPayment(client_secret, {
        payment_method: {
          card: this.paymentDetails,
          billing_details: { name: this.props.fullName }
        }
      })
      //clear the timer
      this.timerId && clearTimeout(this.timerId)
      this.isTimedOut = false

      if (error) {
        // Handle error here
        this.captureError(error)
      } else if (paymentIntent && paymentIntent.status === 'succeeded' && !!paymentIntent.id) {
        onTCPaymentSuccess(paymentIntent)
      } else {
        const errObj = !!error
          ? error
          : {
              code: 'Payment was unsuccessful',
              message: `Unknown payment error, status =  ${paymentIntent &&
                paymentIntent.status}, id=${paymentIntent && paymentIntent.id}`
            }
        this.captureError(errObj)
      }
    } catch (e) {
      this.captureError(e)
    }
  }

  captureError = e => {
    const { onTCPaymentError } = this.props
    onTCPaymentError(e)
    captureWithSentry(e)
  }

  _onBlur = () => {
    if (this.paymentDetails) {
      const { onCheckIt } = this.props
      onCheckIt()
      this.setState({
        hasErrors: this.paymentDetails._complete === false
      })
    }
  }

  render() {
    const { label } = this.props
    const { hasErrors } = this.state
    return (
      <FormField>
        <Label>{label}</Label>
        <StyledPayment hasErrors={hasErrors}>
          <CardElement onBlur={this._onBlur} onReady={this._onReady} {...createOptions()} />
        </StyledPayment>
        {hasErrors && <Error>Oh, you need to type credit card details here</Error>}
      </FormField>
    )
  }
}

export default injectStripe(PaymentDetails)



// WEBPACK FOOTER //
// ./src/components/Form/Payment.js